<template>
  <div
    v-if="Array.isArray(expression_clone)"
    :class="[
      { '!w-fit !min-w-[240px] !h-[30px] whitespace-nowrap': activeWhenThenCursor },
      { '!overflow-auto': activeWhenThenCursor && !showDropdownActive },
      { 'h-full min-w-full min-h-[50px] focus:ring-0': !activeWhenThenCursor }
    ]"
    class="flex-wrap flex items-start">
    <draggable
      v-model="expression_clone"
      draggable=".draggable-item"
      group="metrics"
      :component-data="{ type: 'transition-group', name: !is_drag_on ? 'flip-list' : null }"
      v-bind="{
        sort: false,
        animation: 200,
        group: 'metrics'
      }"
      :class="[{ 'h-40 bg-gray-100 dark:bg-dark-screen-background animate__animated animate__pulse': is_drag_on }]"
      class="flex flex-row flex-wrap items-start h-full min-w-full gap-0 transition-all lead"
      item-key="key"
      @moveIn="moveIn"
      @start="is_drag_on = true"
      @end="is_drag_on = false">
      <template #item="{ element, index }">
        <div
          class="relative flex justify-center rounded-lg group w-fit dark:hover:bg-dark-screen-background"
          :class="[{ '!bg-gray-100': is_drag_on }, { 'draggable-item': !element.not_draggable }]">
          <TransparentComboBoxInput
            v-if="!index"
            v-model="temp_input"
            v-model:active-cursor-index="active_cursor_index"
            :remove-group-items="removeGroupItems"
            :group-key-removed="group_key_removed"
            :object-type="objectType"
            :items="
              possible_options[expression_clone.length] || all_options.filter((o) => !(o.type == 'metric' && o.object_type != objectType))
            "
            :compare-operators="all_options.filter((o) => o.is_compare_operator)"
            :item-index="-1"
            key-id="temp_input"
            :is-last-input="true"
            :input-classes="['w-full', { 'dark:!bg-dark-screen-background': is_drag_on }]"
            classes="flex-1 float-right cursor-text w-fit"
            :active-when-then-cursor="activeWhenThenCursor"
            :ref-id="refId"
            @update:active-cursor-index="
              () => {
                $emit('update:activeWhenThenCursor', refId)
              }
            "
            @add="addElementToFormulary" />

          <template v-if="element?.type == 'input'">
            <InputHolder
              :element="element"
              :group-key-removed="group_key_removed"
              :ref-id="refId"
              :object-type="objectType"
              :active-when-then-cursor="activeWhenThenCursor"
              :active-cursor-index="active_cursor_index"
              :value="expression_clone[index].value"
              :metric="expression_clone[index - 2]"
              :metric-id="expression_clone[index - 2]?.id"
              :data-type="!isNaN(parseInt(expression_clone[index].value)) ? 'Number' : expression_clone[index - 2]?.data_type || 'Number'"
              :operator="expression_clone[index - 1]?.value"
              :input-classes="`text-center`"
              :item-index="index"
              @remove="removeElement(element, index)"
              @update:model-value="
                (v) => {
                  expression_clone[index].value = v
                }
              " />
          </template>
          <template v-else-if="element?.type == 'function' || element?.display == 'TimeDelta' || element?.type == 'nested_metric'">
            {{ whenFirstMetric }}
            <InputHolder
              :active-when-then-cursor="activeWhenThenCursor"
              :active-cursor-index="active_cursor_index"
              :object-type="objectType"
              :metric="whenFirstMetric"
              :value="expression_clone[index]"
              :item-index="index"
              :input-classes="`text-center`"
              @update:model-value="
                (v) => {
                  expression_clone[index].value = v
                }
              "
              @remove="removeElement(element, index)" />
          </template>
          <template v-else>
            <TransparentComboBoxInput
              v-model="expression_clone[index]"
              :compare-operators="all_options.filter((o) => o.is_compare_operator)"
              :remove-group-items="removeGroupItems"
              :group-key-removed="group_key_removed"
              :is-when="isWhen"
              :items="possible_options[index] || all_options.filter((o) => !(o.type == 'metric' && o.object_type != objectType))"
              :object-type="objectType"
              :active-cursor-index="active_cursor_index"
              :length-of-formula="expression_clone.length"
              :item-index="index"
              :label-attr="element.type == 'select_operator' ? 'date_label' : 'label'"
              classes=""
              :input-classes="` `"
              :ref-id="refId"
              :active-when-then-cursor="activeWhenThenCursor"
              @update:active-when-then-cursor="
                () => {
                  $emit('update:activeWhenThenCursor', refId)
                }
              "
              @remove="removeElement(element, index)" />
          </template>

          <TransparentComboBoxInput
            v-model="temp_input"
            v-model:active-cursor-index="active_cursor_index"
            :compare-operators="all_options.filter((o) => o.is_compare_operator)"
            :remove-group-items="removeGroupItems"
            :group-key-removed="group_key_removed"
            :length-of-formula="expression_clone.length"
            :object-type="objectType"
            :items="
              possible_options[expression_clone.length] || all_options.filter((o) => !(o.type == 'metric' && o.object_type != objectType))
            "
            :item-index="index"
            key-id="temp_input"
            :is-last-input="true"
            :input-classes="['w-full', { 'dark:!bg-dark-screen-background': is_drag_on }]"
            classes="flex-1 float-right text-center cursor-text w-fit"
            :active-when-then-cursor="activeWhenThenCursor"
            :ref-id="refId"
            @update:active-when-then-cursor="
              () => {
                $emit('update:activeWhenThenCursor', refId)
              }
            "
            @remove="removeElement(element, index)"
            @add="addElementToFormulary" />
        </div>
      </template>
      <template #footer>
        <TransparentComboBoxInput
          v-if="active_cursor_index == null || !expression_clone.length"
          v-model="temp_input"
          :compare-operators="all_options.filter((o) => o.is_compare_operator)"
          :remove-group-items="removeGroupItems"
          :group-key-removed="group_key_removed"
          :object-type="objectType"
          :items="
            possible_options[expression_clone.length] || all_options.filter((o) => !(o.type == 'metric' && o.object_type != objectType))
          "
          :active-when-then-cursor="activeWhenThenCursor"
          :ref-id="refId"
          key-id="temp_input"
          :is-last-input="true"
          :input-classes="['w-full', { 'dark:!bg-dark-screen-background': is_drag_on }]"
          classes="flex-1 float-right"
          @update:active-when-then-cursor="
            () => {
              $emit('update:activeWhenThenCursor', refId)
            }
          "
          @add="addElementToFormulary" />
      </template>
    </draggable>
  </div>
</template>

<script>
import InputHolder from "@/views/dashboard/admin/metrics/formula-components/InputHolder.vue"
import TransparentComboBoxInput from "@/views/dashboard/admin/metrics/formula-components/TransparentComboBoxInput.vue"
import { consts } from "@/store/constants"
import { utils } from "@/store/helpers"
import draggable from "vuedraggable"
// import { Formulary } from "@/models/metric"
import formulary_options from "@/store/constants/formulary_options.js"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    TransparentComboBoxInput,
    draggable,
    InputHolder
  },
  props: {
    showDropdownActive: null,
    expressionType: {
      type: String,
      default: "value"
    },
    objectType: {
      type: String,
      default: null,
      required: false
    },
    whenFirstMetric: {
      type: Object,
      default: null,
      required: false
    },
    isWhen: {
      type: Boolean,
      default: false
    },
    expression: {
      type: Array,
      default: () => []
    },
    activeWhenThenCursor: null,
    refId: null
  },
  emits: ["update:errors", "errors", "change", "valid", "updateFormulaType", "update:activeWhenThenCursor"],
  data() {
    return {
      group_key_removed: null,
      metrics_with_options: [
        "goals__status",
        "goals__type",
        "tasks__priority",
        "tasks__status",
        "plans__status",
        "plans__type",
        "interactions__category",
        "interactions__origin",
        "interactions__type",
        "goals__assigned_to__email",
        "tasks__assigned_to__email",
        "plans__collaborators__email"
      ],
      all_options: [],
      expression_clone: [],
      is_drag_on: false,
      temp_input: { type: "temp_input", label: "", value: null, name: "", key: utils.generateRandomKey(), display: "" },
      active_cursor_index: null
    }
  },
  computed: {
    possible_options() {
      let re = []
      if (this.expression_clone.length == 0) {
        re = [this.possibleOptions(0)]
      } else {
        re = this.expression_clone.map((_, index) => this.possibleOptions(index))
      }
      return re
    }
  },
  watch: {
    expression_clone: {
      deep: true,
      immediate: true,
      handler() {
        this.verifyFormulary()
        // this.active_cursor_index = this.expression_clone.length
      }
    }
  },
  deactivated() {
    this.unregister_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },
  activated() {
    this.register_listeners()
  },
  created() {
    this.register_listeners()

    let metrics = this.$store.state.metrics.map((m) => {
      m["key"] = utils.generateRandomKey()
      m["display"] = m.name
      m["label"] = m.name
      m["value"] = m.reference_name
      m["type"] = "metric"
      return m
    })
    let forecasting_mappings_metrics = []
    let forecasting_mappings =
      utils.find(this.$store.state.settings.modules_settings, { reference_code: "forecasting_mappings" })?.forecasting_mappings || []
    forecasting_mappings.forEach((m) => {
      forecasting_mappings_metrics.push({
        key: utils.generateRandomKey(),
        type: "forecast_metrics",
        object_type: utils.getObjectTypeById(m.object_type)?.type,
        data_type: m.data_type,
        name: `Renewal Base (${m.name})`,
        display: `Renewal Base (${m.name})`,
        reference_name: `${m.reference_name}_renewal_base`,
        value: `${m.reference_name}_renewal_base`,
        label: `Renewal Base (${m.name})`
      })
      forecasting_mappings_metrics.push({
        key: utils.generateRandomKey(),
        type: "forecast_metrics",
        object_type: utils.getObjectTypeById(m.object_type)?.type,
        data_type: m.data_type,
        name: `Renewal Date (${m.name})`,
        display: `Renewal Date (${m.name})`,
        reference_name: `${m.reference_name}_renewal_date`,
        value: `${m.reference_name}_renewal_date`,
        label: `Renewal Date (${m.name})`
      })
    })
    let global_variables =
      utils.find(this.$store.state.settings.modules_settings, { reference_code: "global_variables" })?.global_variables || []
    global_variables = global_variables.map((m) => {
      m["display"] = `${m.name} (${m.values.find((x) => x.user == this.$store.state.auth.user.id)?.value})`
      m["label"] = m.name
      m["key"] = utils.generateRandomKey()
      m["data_type"] = m.input_type
      m["type"] = "global_variable"
      m["value"] = "global_variables_" + m.reference_name
      return m
    })

    let owners = this.$store.state.data.users.map((m) => {
      m["label"] = m.full_name
      m["value"] = m.email
      return m
    })
    this.all_options = consts.FORMULARY_OPTIONS.concat(metrics)
      .concat(forecasting_mappings_metrics)
      .concat(global_variables)
      .map((x) => {
        if (
          ["owner__email", "goals__assigned_to__email", "tasks__assigned_to__email", "plans__collaborators__email"].includes(
            x.reference_name
          )
        ) {
          x["options"] = owners
        }
        return utils.setRandomKey(x)
      })

    if (Array.isArray(this.expression)) {
      this.expression_clone = this.$utils.clone(this.expression)
    } else {
      this.expression_clone = this.serverStringToExpressionString(this.$utils.clone(this.expression))
    }
    this.active_cursor_index = this.expression_clone.length - 1
  },
  methods: {
    removeGroupItems(key) {
      this.group_key_removed = key
    },
    serverStringToExpressionString(exp) {
      const full_list = formulary_options.concat(this.$store.state.metrics)
      const list_calc = []
      exp.split(" ").forEach((item) => {
        if (
          full_list.find((option) => (option.display && option.display == item) || (option.reference_name && option.reference_name == item))
        ) {
          const found_obj = {
            ...full_list.find(
              (option) => (option.display && option.display == item) || (option.reference_name && option.reference_name == item)
            ),
            key: this.$uuid()
          }
          list_calc.push(found_obj)
        } else {
          list_calc.push({
            value: exp,
            display: exp,
            type: "input",
            key: this.$uuid()
          })
        }
      })
      return list_calc
    },
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.ADD_ELEMENT_TO_FORMULARY, (el) => {
        this.addElementToFormulary(el)
      })

      this.$emitter.on(ALL_EMITTERS.DRAG_IS_ON_IN_EXPRESSION_HOLDER, (st) => {
        this.is_drag_on = st
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.ADD_ELEMENT_TO_FORMULARY)
      this.$emitter.off(ALL_EMITTERS.DRAG_IS_ON_IN_EXPRESSION_HOLDER)
    },
    possibleOptions(index) {
      let extra_options = []
      if (index == 0 && !this.isWhen) {
        extra_options = this.all_options.filter((x) => x.type == "cases")
      }
      if (this.isWhen && this.expressionType == "filter") {
        this.all_options = this.all_options.filter((x) => x.type != "function")
      }
      if (this.expressionType == "value") {
        if (index == 0) {
          return extra_options
            .concat(this.all_options.filter((x) => x.type != "cases").filter((o) => !o.is_compare_operator || o.type == "function"))
            .filter(
              (o) =>
                !(
                  (o.type == "metric" ||
                    o.type != "other_metrics" ||
                    (o.type == "forecast_metrics" &&
                      !["forecasts__forecast_status", "forecasts__forecast_type"].includes(o.reference_name))) &&
                  ((o?.object_type && o.object_type != this.objectType) || false)
                )
            )
        } else {
          return extra_options
            .concat(this.all_options.filter((x) => x.type != "cases").filter((o) => !o.is_compare_operator))
            .filter(
              (o) =>
                !(
                  (o.type == "metric" ||
                    o.type != "other_metrics" ||
                    (o.type == "forecast_metrics" &&
                      !["forecasts__forecast_status", "forecasts__forecast_type"].includes(o.reference_name))) &&
                  ((o?.object_type && o.object_type != this.objectType) || false)
                )
            )
        }
      } else {
        return this.all_options
          .filter((o) => o.type != "cases")
          .filter(
            (o) =>
              !(
                (o.type == "metric" ||
                  o.type != "other_metrics" ||
                  (o.type == "forecast_metrics" &&
                    !["forecasts__forecast_status", "forecasts__forecast_type"].includes(o.reference_name))) &&
                ((o?.object_type && o.object_type != this.objectType) || false)
              )
          )
      }
    },

    verifyFormulary() {
      let errors = []

      this.$emit("change", this.expression_clone)
      this.$emit("errors", errors)
    },

    moveIn(el) {
      if (el?.type == "cases") {
        this.$emit("updateFormulaType", el?.type)
      }
    },
    addElementToFormulary(e) {
      let el = utils.setRandomKey(e)
      const index_to_add_to = this.active_cursor_index + 1
      if (el?.type == "cases") {
        this.$emit("updateFormulaType", el?.type)
      } else {
        this.expression_clone.splice(index_to_add_to, 0, el)
        this.expression_clone = JSON.parse(JSON.stringify(this.expression_clone))
        if (el?.type == "other_metrics" && this.metrics_with_options.includes(el.reference_name)) {
          const group_key = utils.generateRandomKey()
          this.expression_clone[index_to_add_to]["not_draggable"] = true

          this.expression_clone[index_to_add_to]["group_key"] = group_key

          this.expression_clone.splice(index_to_add_to + 1, 0, {
            type: "operator",
            is_compare_operator: true,
            display: "=",
            value: "==",
            not_draggable: true,
            key: utils.generateRandomKey(),
            label: "Equal To",
            group_key: group_key
          })
          this.expression_clone.splice(index_to_add_to + 2, 0, {
            type: "input",
            value: "",
            not_draggable: true,
            key: utils.generateRandomKey(),
            display: el?.display,
            group_key: group_key
          })
          this.active_cursor_index += 3
        } else if (el?.type == "other_metrics" && el.data_type == "Boolean") {
          const group_key = utils.generateRandomKey()

          this.expression_clone[index_to_add_to]["not_draggable"] = true
          this.expression_clone[index_to_add_to]["group_key"] = group_key

          this.expression_clone.splice(index_to_add_to + 1, 0, {
            type: "operator",
            is_compare_operator: true,
            display: "=",
            not_draggable: true,
            group_key: group_key,
            value: "==",
            key: utils.generateRandomKey(),
            label: "Equal To"
          })
          this.expression_clone.splice(index_to_add_to + 2, 0, {
            type: "input",
            value: true,
            not_draggable: true,
            key: utils.generateRandomKey(),
            data_type: "Boolean",
            display: el?.display,
            group_key: group_key
          })

          this.active_cursor_index += 3
        } else if (
          el?.type == "date_extractor" &&
          (el.value == "DateYear" || el.value == "DateMonth" || el.value == "DateDay" || el.value == "DateQuarter")
        ) {
          const group_key = utils.generateRandomKey()

          this.expression_clone[index_to_add_to]["not_draggable"] = true
          this.expression_clone[index_to_add_to]["group_key"] = group_key

          this.expression_clone.splice(index_to_add_to + 1, 0, {
            type: "operator",
            is_compare_operator: true,
            display: "=",
            not_draggable: true,
            group_key: group_key,
            value: "==",
            key: utils.generateRandomKey(),
            label: "Equal To"
          })
          this.expression_clone.splice(index_to_add_to + 2, 0, {
            type: "input",
            value: "",
            not_draggable: true,
            key: utils.generateRandomKey(),
            display: el?.display,
            group_key: group_key
          })

          this.active_cursor_index += 3
        } else if (el?.type == "forecast_metrics" && el.reference_name == "forecasts__forecast_status") {
          const group_key = utils.generateRandomKey()

          this.expression_clone[index_to_add_to]["not_draggable"] = true
          this.expression_clone[index_to_add_to]["group_key"] = group_key

          this.expression_clone.splice(index_to_add_to + 1, 0, {
            type: "operator",
            is_compare_operator: true,
            group_key: group_key,
            display: "=",
            not_draggable: true,
            value: "==",
            key: utils.generateRandomKey(),
            label: "Equal To"
          })

          this.expression_clone.splice(index_to_add_to + 2, 0, {
            type: "input",
            value: "forecasted",
            not_draggable: true,
            key: utils.generateRandomKey(),
            display: el?.display,
            group_key: group_key
          })

          this.active_cursor_index += 3
        } else if (
          (el?.type == "forecast_metrics" && el.reference_name == "forecasts__forecasted_date") ||
          (el?.type == "other_metrics" && el.reference_name == "goals__due_date") ||
          (el?.type == "other_metrics" && el.reference_name == "tasks__due_date") ||
          (el?.type == "other_metrics" && el.reference_name == "plans__due_date") ||
          (el?.type == "other_metrics" && el.reference_name == "plans__start_date") ||
          (el?.type == "other_metrics" && el.reference_name == "interactions__interaction_date")
        ) {
          const group_key = utils.generateRandomKey()
          this.expression_clone[index_to_add_to]["group_key"] = group_key
          this.expression_clone[index_to_add_to]["not_draggable"] = true

          this.expression_clone.splice(index_to_add_to + 1, 0, {
            type: "select_operator",
            group_key: group_key,
            not_draggable: true,
            key: utils.generateRandomKey(),
            label: "Select Operator"
          })

          this.expression_clone.splice(index_to_add_to + 2, 0, {
            type: "input",
            data_type: "Date",
            not_draggable: true,
            group_key: group_key,
            value: "",
            key: utils.generateRandomKey(),
            display: el?.display
          })

          this.active_cursor_index += 3
        } else if (el?.type == "metrics" && el.reference_name == "owner__email") {
          const group_key = utils.generateRandomKey()

          this.expression_clone[index_to_add_to]["not_draggable"] = true
          this.expression_clone[index_to_add_to]["group_key"] = group_key

          this.expression_clone.splice(index_to_add_to + 1, 0, {
            type: "operator",
            is_compare_operator: true,
            group_key: group_key,
            display: "=",
            not_draggable: true,
            value: "==",
            key: utils.generateRandomKey(),
            label: "Equal To"
          })
          this.expression_clone.splice(index_to_add_to + 2, 0, {
            type: "input",
            value: "",
            not_draggable: true,
            key: utils.generateRandomKey(),
            display: el?.display,
            group_key: group_key
          })
          this.active_cursor_index += 3
        } else if (el?.type == "other_metrics" && el.reference_name == "tags__name") {
          const group_key = utils.generateRandomKey()

          this.expression_clone[index_to_add_to]["not_draggable"] = true
          this.expression_clone[index_to_add_to]["group_key"] = group_key

          this.expression_clone.splice(index_to_add_to + 1, 0, {
            type: "operator",
            is_compare_operator: true,
            display: "=",
            not_draggable: true,
            value: "==",
            key: utils.generateRandomKey(),
            group_key: group_key,
            label: "Equal To"
          })
          this.expression_clone.splice(index_to_add_to + 2, 0, {
            type: "input",
            value: "",
            not_draggable: true,
            key: utils.generateRandomKey(),
            group_key: group_key,
            display: el?.display
          })
          this.active_cursor_index += 3
        } else if (el?.type == "forecast_metrics" && el.reference_name == "forecasts__forecast_type") {
          const group_key = utils.generateRandomKey()

          this.expression_clone[index_to_add_to]["not_draggable"] = true
          this.expression_clone[index_to_add_to]["group_key"] = group_key

          this.expression_clone.splice(index_to_add_to + 1, 0, {
            type: "operator",
            is_compare_operator: true,
            display: "=",
            not_draggable: true,
            value: "==",
            group_key: group_key,
            key: utils.generateRandomKey(),
            label: "Equal To"
          })

          this.expression_clone.splice(index_to_add_to + 2, 0, {
            type: "input",
            value: "renewal",
            not_draggable: true,
            key: utils.generateRandomKey(),
            group_key: group_key,
            display: el?.display
          })
          this.active_cursor_index += 3
        } else if (el?.type == "metric" && el.data_type == "Boolean") {
          const group_key = utils.generateRandomKey()

          this.expression_clone[index_to_add_to]["not_draggable"] = true
          this.expression_clone[index_to_add_to]["group_key"] = group_key

          this.expression_clone.splice(index_to_add_to + 1, 0, {
            type: "operator",
            is_compare_operator: true,
            display: "=",
            not_draggable: true,
            value: "==",
            group_key: group_key,
            key: utils.generateRandomKey(),
            label: "Equal To"
          })

          this.expression_clone.splice(index_to_add_to + 2, 0, {
            type: "input",
            value: true,
            not_draggable: true,
            key: utils.generateRandomKey(),
            group_key: group_key,
            data_type: "Boolean",
            display: el?.display
          })
          this.active_cursor_index += 3
        } else if (el?.type == "operator") {
          const group_key = utils.generateRandomKey()

          this.expression_clone[index_to_add_to]["not_draggable"] = true
          this.expression_clone[index_to_add_to]["group_key"] = group_key

          if (el?.display == "In Date Range") {
            this.expression_clone.splice(index_to_add_to + 1, 0, {
              type: "input",
              not_draggable: true,
              value: { start: null, end: null },
              key: utils.generateRandomKey(),
              group_key: group_key,
              display: el?.display
            })
            this.active_cursor_index += 2
          } else if (el?.display == "In Range") {
            this.expression_clone.splice(index_to_add_to + 1, 0, {
              type: "input",
              not_draggable: true,
              value: { start: null, end: null },
              key: utils.generateRandomKey(),
              group_key: group_key,
              display: el?.display
            })
            this.active_cursor_index += 2
          } else {
            this.active_cursor_index += 1
          }
        } else {
          this.active_cursor_index += 1
        }
      }

      this.temp_input = { type: "temp_input", key: utils.generateRandomKey(), display: "" }
    },
    removeElement(element, index) {
      this.expression_clone.splice(index, 1)
      if (this.active_cursor_index !== null && this.active_cursor_index !== -1) {
        this.active_cursor_index = this.active_cursor_index - 1
      }
    }
  }
}
</script>
